import React, { FC } from 'react';
import { ArrowLeftSmall } from '@wix/wix-ui-icons-common';
import { Box, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';
import { templatesPath } from '@components/Hooks/useRouter';
import { TEMPLATES_GALLERY_ENTRY } from '@utils/constants';

import s from './BackToGalleryButton.module.scss';

type Props = {
  entry?: string;
};

const BackToGalleryButton: FC<Props> = ({ entry }) => {
  const { logBiClick } = useTemplateBi({ is_mobile: false });
  const { t } = useTranslation();

  return entry === TEMPLATES_GALLERY_ENTRY ? (
    <Box className={s.backToTemplateCta}>
      <TextButton
        size="small"
        onClick={() =>
          logBiClick({ clickType: 'Back to Wix Studio templates' })
        }
        as="a"
        target="_self"
        href={templatesPath}
        skin="dark"
        prefixIcon={<ArrowLeftSmall />}
      >
        {t('marketplace.templates-page.back-to-studio-templates-cta')}
      </TextButton>
    </Box>
  ) : (
    <Box height="66px"></Box>
  );
};

export default BackToGalleryButton;
